// extracted by mini-css-extract-plugin
export default {"table-wrapper":"Table_table-wrapper__4iEkK","table":"Table_table__FExWz"};